import DateFacetedFilter from "@/pages/(app)/returns/list/components/faceted/date-faceted-filter";
import StringFacetedFilter from "@/pages/(app)/returns/list/components/faceted/string-faceted-filter";
import type {
  DateFrontFilterValue,
  StringFrontFilterValue,
} from "@/pages/(app)/returns/providers/return-requests-filters.provider";
import { useReturnRequestsFilters } from "@/pages/(app)/returns/providers/use-return-requests-filters";
import { DateFilterName, StringFilterName } from "../../utils/types";

export default function FacetedFilters() {
  const { filtersDefinition, filters } = useReturnRequestsFilters();

  const filtersArray = Array.from(filters.entries());

  if (!filtersArray.length) return null;

  return (
    <div className="flex gap-2 flex-wrap mt-4">
      {filtersArray.map(([name, filter], index) => {
        const filterDefinition = filtersDefinition.get(name);

        if (!filterDefinition) return null;

        if (filterDefinition.type === "string") {
          return (
            <StringFacetedFilter
              key={index}
              filterDefinition={filterDefinition}
              filterName={name as StringFilterName}
              filter={filter as StringFrontFilterValue}
            />
          );
        }
        if (filterDefinition.type === "date") {
          return (
            <DateFacetedFilter
              key={index}
              filterDefinition={filterDefinition}
              filterName={name as DateFilterName}
              filter={filter as DateFrontFilterValue}
            />
          );
        }
      })}
    </div>
  );
}
